import moment from "moment";
import { isCustomerSite } from "../utils/getsubDomain";

export const chooseDisplayedPrice = ({ price, farePrice }) => {
  if (isCustomerSite()) {
    return farePrice || price;
  }
  return price;
};

export function getDateRangeFromFilter(timeFilter) {
  const now = moment(timeFilter?.date || undefined);

  let startDate, endDate;

  switch (timeFilter.range) {
    case "hour":
      startDate = now.clone().startOf("hour");
      endDate = now.clone().endOf("hour");
      break;
    case "day":
      startDate = now.clone().startOf("day");
      endDate = now.clone().endOf("day");
      break;
    case "week":
      startDate = now.clone().startOf("isoWeek");
      endDate = now.clone().endOf("isoWeek");
      break;
    case "month":
      startDate = now.clone().startOf("month");
      endDate = now.clone().endOf("month");
      break;
    case "year":
      startDate = now.clone().startOf("year");
      endDate = now.clone().endOf("year");
      break;
    case "all":
    default:
      // All time: you may set these to earliest/latest possible, or leave undefined.
      startDate = moment("1970-01-01T00:00:00.000Z");
      endDate = now.clone().endOf("year"); // Or moment() if you want "now"
      break;
  }

  return {
    startDate: startDate.toISOString(),
    endDate: endDate.toISOString(),
  };
}
